import { Pressable, PressableProps } from 'react-native';
import styles from './styles';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import { useOnHover } from '@/hooks/useOnHover';

interface ButtonProps extends PressableProps {
  label?: string;
  onPress: () => void;
  disabled?: boolean;
  look?: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'ghost';
  icon?: React.ComponentProps<typeof Icon>['name'];
}

export const Button: React.FC<ButtonProps> = ({
  onPress,
  disabled,
  look = 'primary',
  icon,
  label,
  style,
  testID,
}) => {
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();

  return (
    <Pressable
      testID={testID}
      onPress={onPress}
      disabled={disabled}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      style={({ pressed }) => [
        styles.common,
        style,
        disabled ? styles[`${look}Disabled`] : styles[look],
        isHovered && !disabled ? styles[`${look}Hovered`] : {},
        pressed ? styles[`${look}Pressed`] : {},
      ]}
    >
      {({ pressed }) => (
        <>
          {icon && (
            <Icon
              name={icon}
              style={{
                ...styles[`${look}Label`],
                ...(isHovered && !disabled
                  ? styles[`${look}LabelHovered`]
                  : null),
                ...(disabled ? styles[`${look}LabelDisabled`] : {}),
                ...(pressed ? styles[`${look}LabelPressed`] : {}),
              }}
              size={20}
            />
          )}
          {label && (
            <Text
              style={[
                styles.commonLabel,
                styles[`${look}Label`],
                isHovered && !disabled ? styles[`${look}LabelHovered`] : {},
                disabled ? styles[`${look}LabelDisabled`] : {},
                pressed ? styles[`${look}LabelPressed`] : {},
                icon && { marginLeft: 12 },
              ]}
            >
              {label}
            </Text>
          )}
        </>
      )}
    </Pressable>
  );
};
